import { createRouter, createWebHistory } from 'vue-router'
import MakeTestimonial from './views/MakeTestimonial.vue';
import ProductRating from './views/ProductRating.vue';
import ProductRatingFrame from './views/ProductRatingFrame.vue';
import StoreRating from './views/StoreRating.vue';


const routes = [
  {
    path: '/testimonial/:id',
    name: 'MakeTestimonial',
    component: MakeTestimonial,
    props:true,
    meta:{ title: "Deixe sua avaliação | Cansei de ser gato"}
  },
  {
    path: '/',
    name: 'StoreRating',
    component: StoreRating,
    meta:{ title: "Avaliações sobre a loja | Cansei de ser gato"}
  },
  {
    path: '/product/:sku',
    name: 'ProductRating',
    component: ProductRating,
    props:true,
    meta:{ title: "Avaliações sobre o produto | Cansei de ser gato"}
  },
  {
    path: '/frame/product/:sku',
    name: 'ProductRatingFrame',
    component: ProductRatingFrame,
    props:true,
    meta:{ title: "Avaliações sobre o produto | Cansei de ser gato"}
  }
];

const router = createRouter({
    history: createWebHistory(),
    routes
  })

// Atualizar o título da página ao mudar de rota
router.beforeEach((to, from, next) => {
  // Define o título da página baseado na meta da rota
  document.title = to.meta.title || 'Título Padrão'; // Título padrão se não houver
  next();
});
export default router;
